import { combineReducers } from 'redux'

import fullpageLoaderReducers from './fullpage-loader/reducers'
import campaignReducers from './campaign/reducers'
import storeReducers from './store/reducers'
import voucherReducers from './voucher/reducers'
import loginReducers from './login/reducers'
import dashboardReducers from './dashboard/reducers'
import stepperReducers from './stepper/reducers'
import headerReducers from './header/reducers'
import configReducers from './config/reducers'

export default combineReducers({
  fullpageLoaderReducers,
  campaignReducers,
  storeReducers,
  voucherReducers,
  loginReducers,
  dashboardReducers,
  stepperReducers,
  headerReducers,
  configReducers
})
